import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AspOrderListComponent } from './asp-order-list.component';
import { RouterModule, Routes } from '@angular/router';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ApplicationPipesModule } from 'app/main/applicationPipesModule.module';
import { AspOrderDetailsComponent } from '../asp-order-details/asp-order-details.component';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatButtonModule } from '@angular/material/button';
import { MatPaginatorModule } from '@angular/material/paginator';

const routes: Routes = [
  {
      path: 'order-list',
      component: AspOrderListComponent,
  },
  { path: 'order-details/:id', component: AspOrderDetailsComponent },
];

@NgModule({
  declarations: [AspOrderListComponent],
  imports: [
    RouterModule.forChild(routes),
    CommonModule,
    BrowserModule,
    FormsModule,
    CommonModule,
    MatIconModule,
    MatExpansionModule,
    MatCheckboxModule,
    BrowserAnimationsModule,
    MatProgressBarModule,
    ApplicationPipesModule,
    MatBottomSheetModule,
    MatButtonModule,
    MatPaginatorModule
    
  ],
  
  exports: [AspOrderListComponent],
})
export class AspOrderListModule { }
